module.exports = __webpack_public_path__ + "static/daredevil-pedals-footer-88a291af949084f5c62e4cdaf9242a1d.png";